// import { get } from 'svelte/store';


import Layout from 'layouts/Layout.svelte';


// Forms

import FormsIndex from 'views/forms/Index.svelte';

import FormsSubmitted from 'views/forms/Submitted.svelte';


// Form

import FormAdultHockeyFreeAgent from 'views/form/AdultHockeyFreeAgent.svelte';

import FormSpringHockeyFreeAgent from 'views/form/SpringHockeyFreeAgent.svelte';

import FormTeamInstanceJerseySponsorOrder from 'views/form/TeamInstanceJerseySponsorOrder.svelte';

import FormSelectsYoungGunsSponsors from 'views/form/SelectsYoungGunsSponsors.svelte';

import FormTest from 'views/form/Test.svelte';

// Other

import Contact from 'views/Contact.svelte';


// Not Found

import NotFound from 'views/NotFound.svelte';




const routes = [
	// Forms
	{
		name: 'forms',
		component: FormsIndex,
		layout: Layout,
	},
	{
		name: 'submitted',
		component: FormsSubmitted,
		layout: Layout,
	},
	// Form
	{
		name: 'form/adult-hockey-free-agent/:season_instance_id',
		component: FormAdultHockeyFreeAgent,
		layout: Layout,
	},
	{
		name: 'form/spring-hockey-free-agent/:season_instance_id',
		component: FormSpringHockeyFreeAgent,
		layout: Layout,
	},
	{
		name: 'form/team-instance-jersey-sponsor-order/:season_instance_id',
		component: FormTeamInstanceJerseySponsorOrder,
		layout: Layout,
	},
	{
		name: 'form/test',
		component: FormTest,
		layout: Layout,
	},
	{
		name: 'form/selects-young-guns-fundraising',
		component: FormSelectsYoungGunsSponsors,
		layout: Layout,
	},
	// Other
	{
		name: 'contact',
		component: Contact,
		layout: Layout,
	},
	// Not Found
	{
		name: '404',
		path: '404',
		component: NotFound,
	}
]



export { routes };



